module.exports = __webpack_public_path__ + "img/reference-rosales.7dcd780f.webp";